import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { TuiSizeL, TuiSizeM } from '@taiga-ui/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { ActionItemModel } from '@src/app/modules/actions';

import { LoyaltyProgramApiService } from '../../services';

@Component({
  selector: 'lp-export-codes-button',
  templateUrl: './export-codes-button.component.html',
  styleUrls: ['./export-codes-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportCodesButtonComponent extends BaseResizableComponent {
  private readonly lpApiService = inject(LoyaltyProgramApiService);
  private readonly translateService = inject(TranslateService);

  @Input() productGroupId?: string;
  @Input() unionId?: string;

  @Input() size: TuiSizeM | TuiSizeL = 'm';

  moreMenuItems: ActionItemModel[] = [
    {
      title: this.translateService.instant('components.exportCodesButton.labels.downloadCodes'),
      icon: '@tui.download',
      visible: true,
      action: () => this.downloadCodes(),
    },
    {
      title: this.translateService.instant('components.exportCodesButton.labels.deleteCodes'),
      icon: '@tui.trash-2',
      visible: true,
      action: () => this.deleteCodes(),
      color: 'var(--unions-color-red)',
    },
  ];

  downloadCodes() {
    this.lpApiService.downloadCodesByGroupId(this.productGroupId, this.unionId);
  }

  deleteCodes() {
    this.lpApiService.deleteCodesByGroupId(this.productGroupId);
  }
}
